<div class="alert-container" popover="manual" #container>
  @for (alert of toastService.alerts(); track alert.id) {
    <app-alert
      [message]="alert.message"
      [type]="alert.type"
      [duration]="0">
    </app-alert>
  }
</div>

